import { DateRangePicker as EJ2DateRangePicker } from '@syncfusion/ej2-calendars';
import { Base } from './base-module';
/**
 * The `DateRangePicker` module is used configure the properties of Date range picker type editor.
 */
export class DateRangePicker {
    constructor(parent) {
        this.compObj = undefined;
        this.parent = parent;
        this.parent.dateRangeModule = this;
        this.base = new Base(this.parent, this);
    }
    render(e) {
        this.compObj = new EJ2DateRangePicker(this.parent.model);
        this.compObj.appendTo(e.target);
    }
    focus() {
        this.compObj.element.focus();
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the string
     */
    getModuleName() {
        return 'date-range-picker';
    }
    updateValue(e) {
        if (this.compObj && e.type === 'DateRange') {
            this.parent.setProperties({ value: this.compObj.value }, true);
            this.parent.extendModelValue(this.compObj.value);
        }
    }
    /**
     * Destroys the module.
     *
     * @function destroy
     * @returns {void}
     * @hidden
     */
    destroy() {
        this.base.destroy();
    }
}
